import { Component, OnInit } from '@angular/core';
import { DonerType } from '../../../../../shared/schemas/donersSchema';
import { DonersService } from './sevices/doners.service';
import labels from './../doners/data/doners.json';

@Component({
  selector: 'app-doners',
  templateUrl: './doners.component.html',
  styleUrl: './doners.component.scss',
})
export class DonersComponent implements OnInit {
  doners: DonerType[] = [];
  header: string = labels.header;

  constructor(private donersService: DonersService) {}

  ngOnInit(): void {
    this.loadDoners();
  }

  async loadDoners(): Promise<void> {
    try {
      this.doners = await this.donersService.getDoners();
    } catch (error) {
      console.error('Error fetching doners:', error);
    }
  }
}